import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Register } from "../components/Register";
import { Footer } from "../components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-paper font-sans text-ink antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Register />
      </main>
      <Footer />
    </div>
  );
}
